import PropTypes from "prop-types";

export default function ServiceBox({ icon, size = "md" }) {
  const sizes = {
    md: { box: "w-24 h-24", icon: "text-3xl" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div
      className={`
        ${s.box} flex items-center justify-center
        rotate-45 shadow-md
        bg-gradient-to-b from-[#1FA2A6] to-[#28B485]
      `}
    >
      <div className={`-rotate-45 text-white ${s.icon}`}>
        {icon}
      </div>
    </div>
  );
}

ServiceBox.propTypes = {
  icon: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};
